import { render, staticRenderFns } from "./buttonSave.vue?vue&type=template&id=3bc4be7e&"
import script from "./buttonSave.vue?vue&type=script&lang=js&"
export * from "./buttonSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports